<template>
  <div>
    <div class="basic-menu">
      <div class="logo pointer" @click="jump"></div>
      <div class="menu-part">
        <el-menu :default-active="activeIndex2"
                 class="el-menu-demo"
                 mode="horizontal"
                 @select="handleSelect"
                 background-color="#060C7A"
                 text-color="#fff"
                 active-text-color="#ffd04b">
          <el-menu-item index="1">栏目1</el-menu-item>
          <el-submenu index="2">
            <template slot="title"  >栏目2</template>
            <el-menu-item index="2-1">选项1</el-menu-item>
            <el-menu-item index="2-2">选项2</el-menu-item>
            <el-menu-item index="2-3">选项3</el-menu-item>
<!--            <el-submenu index="2-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="2-4-1">选项1</el-menu-item>-->
<!--              <el-menu-item index="2-4-2">选项2</el-menu-item>-->
<!--              <el-menu-item index="2-4-3">选项3</el-menu-item>-->
<!--            </el-submenu>-->
          </el-submenu>
          <el-menu-item index="3">栏目3</el-menu-item>
          <el-submenu index="4">
            <template slot="title">栏目4</template>
            <el-menu-item index="4-1">选项1</el-menu-item>
            <el-menu-item index="4-2">选项2</el-menu-item>
            <el-menu-item index="4-3">选项3</el-menu-item>
          </el-submenu>
          <el-menu-item index="5">栏目5</el-menu-item>
          <el-submenu index="6">
            <template slot="title">栏目6</template>
            <el-menu-item index="6-1">选项1</el-menu-item>
            <el-menu-item index="6-2">选项2</el-menu-item>
            <el-menu-item index="6-3">选项3</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "NaviBar",
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {
    jump() {
      window.open("https://www.repe.com.cn/");
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}



</script>



<style scoped>

@import "../assets/css/header.css";
</style>



// WEBPACK FOOTER //
// src/components/NaviBar.vue